// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1JaJz","index":"styles_index__1NcAe"};